import { combineReducers } from "redux";

import * as all from "./all";
import * as status from "./status";
import * as startTime from "./startTime";

export const reducer = combineReducers({
  all: all.reducer,
  status: status.reducer,
  startTime: startTime.reducer,
});

export interface StoreState {
  all: all.StoreState;
  status: status.StoreState;
  startTime: startTime.StoreState;
}
